export default "__VITE_ASSET__Br5C$xU$__"